import type { ApplePayTheme } from 'types/applePay';
import type { StripeApplePayButtonOptions } from 'types/stripe';

export const STRIPE_BUTTON_THEMES: Record<ApplePayTheme, StripeApplePayButtonOptions> = {
  buy: {
    height: undefined,
    theme: 'black',
    type: 'buy'
  },
  cart: {
    height: 42,
    theme: 'white-outline',
    type: 'plain'
  },
  express: {
    height: 55,
    theme: 'white-outline',
    type: 'plain'
  }
};
